module.exports = __webpack_public_path__ + "img/phone-only.207a2b91.svg";